<template>
  <div
    class="menuBar p-3 fadeinup animation-duration-500 animation-iteration-1 flex align-items-center z-5 "
  >
    <img src="../assets/logo.png" style="width: 50px; height: 50px" />
    <span class="p-2 text-2xl w-full">
      Giosuè Addario
    </span>
    <div class="w-full p-2 flex align-items-center  justify-content-center">
      <div
        class="p-2 text-xl cursor-pointer flex align-items-center"
        @click="routerLink('#home')"
      >
        Home
      </div>
      <span
        class="p-2 text-xl cursor-pointer flex align-items-center"
        @click="routerLink('#projects')"
        >Progetti</span
      >
      <span
        class="p-2 text-xl cursor-pointer flex align-items-center"
        @click="routerLink('#cv')"
        >CV</span
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Header",
  computed: {
    ...mapGetters({}),
  },
  mounted() {
    //window.addEventListener("scroll", this.updateScroll);
  },
  methods: {
    routerLink(link) {
      this.$router.push({
        path:'/',
        hash:link
      })
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only 
-->
<style scoped lang="scss">
.menuBar {
  width: 100%;
  // background: linear-gradient(120deg, rgba(127, 112, 245,0.6),rgba(14, 160, 255,0.6));//rgba(117, 117, 117, 0.3);
  background: var(--color1) !important;
  position: sticky;
  color: var(--color3);
  top: 0;
}

/*
.change_color {
  background: linear-gradient(
    120deg,
    rgba(127, 112, 245, 1),
    rgba(14, 160, 255, 1)
  ) !important;
}*/
</style>
